import { render, staticRenderFns } from "./claudiaFileDownloader.vue?vue&type=template&id=5c24ff86"
import script from "./claudiaFileDownloader.vue?vue&type=script&lang=js"
export * from "./claudiaFileDownloader.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {S2TreeDisplay: require('/usr/src/app/node_modules/front-components/components/ui/tree/TreeDisplay.vue').default})
